import React from "react";
const IconDoubleChevronUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.5 9.75L10 4.25L4.5 9.75" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path d="M15.5 15.75L10 10.25L4.5 15.75" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
  </svg>
);
export default IconDoubleChevronUp;
